/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CancellationPolicyInfoDto } from './cancellation-policy-info-dto';
import {
    CancellationPolicyInfoDtoFromJSON,
    CancellationPolicyInfoDtoFromJSONTyped,
    CancellationPolicyInfoDtoToJSON,
    CancellationPolicyInfoDtoToJSONTyped,
} from './cancellation-policy-info-dto';

/**
 * 
 * @export
 * @interface BookingInfoResponse
 */
export interface BookingInfoResponse {
    /**
     * Уникальный идентификатор заказа
     * @type {string}
     * @memberof BookingInfoResponse
     */
    id: string;
    /**
     * Текущий статус заказа
     * @type {string}
     * @memberof BookingInfoResponse
     */
    status: string;
    /**
     * Ключ идемпотентности для предотвращения дублирования запросов
     * @type {string}
     * @memberof BookingInfoResponse
     */
    idempKey: string;
    /**
     * Дата и время создания заказа (в формате ISO 8601 с наносекундной точностью)
     * @type {Date}
     * @memberof BookingInfoResponse
     */
    createdAt: Date;
    /**
     * Дата и время последнего обновления заказа
     * @type {Date}
     * @memberof BookingInfoResponse
     */
    updatedAt: Date;
    /**
     * Общая стоимость бронирования
     * @type {number}
     * @memberof BookingInfoResponse
     */
    total: number;
    /**
     * Сумма предоплаты
     * @type {number}
     * @memberof BookingInfoResponse
     */
    prepayment: number;
    /**
     * Номер заказа во внешней системе (например, в PMS)
     * @type {string}
     * @memberof BookingInfoResponse
     */
    externalNumber: string;
    /**
     * Время создания заказа во внешней системе (UTC)
     * @type {Date}
     * @memberof BookingInfoResponse
     */
    externalCreatedAt: Date;
    /**
     * 
     * @type {CancellationPolicyInfoDto}
     * @memberof BookingInfoResponse
     */
    cancellationPolicy: CancellationPolicyInfoDto;
    /**
     * Список кодов размещения (типов номеров/условий размещения)
     * @type {Array<string>}
     * @memberof BookingInfoResponse
     */
    placementCodes: Array<string>;
    /**
     * Количество взрослых гостей
     * @type {number}
     * @memberof BookingInfoResponse
     */
    adultCount: number;
    /**
     * Идентификатор объекта размещения (отеля)
     * @type {string}
     * @memberof BookingInfoResponse
     */
    propertyId: string;
    /**
     * Идентификатор тарифного плана
     * @type {string}
     * @memberof BookingInfoResponse
     */
    ratePlanId: string;
    /**
     * Идентификатор типа номера
     * @type {string}
     * @memberof BookingInfoResponse
     */
    roomTypeId: string;
    /**
     * Количество отзывов, оставленных пользователем (или количество букв в отзыве? требует уточнения)
     * @type {number}
     * @memberof BookingInfoResponse
     */
    countLettersReview?: number;
    /**
     * Дата и время заезда (локальное время отеля, без часового пояса в примере)
     * @type {Date}
     * @memberof BookingInfoResponse
     */
    arrival: Date;
    /**
     * Дата и время выезда (локальное время отеля)
     * @type {Date}
     * @memberof BookingInfoResponse
     */
    departure: Date;
    /**
     * Возраст детей (в годах). Пустой массив — нет детей.
     * @type {Array<number>}
     * @memberof BookingInfoResponse
     */
    childAges: Array<number>;
    /**
     * Тип питания по тарифу
     * @type {string}
     * @memberof BookingInfoResponse
     */
    mealPlan: string;
    /**
     * 
     * @type {string}
     * @memberof BookingInfoResponse
     */
    fullPlacementsName?: string;
    /**
     * Контрольная сумма для валидации данных бронирования (в формате base64 или хеш)
     * @type {string}
     * @memberof BookingInfoResponse
     */
    checksum: string;
    /**
     * Токен для создания бронирования. Действителен ограниченное время.
     * @type {string}
     * @memberof BookingInfoResponse
     */
    createBookingToken: string;
}

/**
 * Check if a given object implements the BookingInfoResponse interface.
 */
export function instanceOfBookingInfoResponse(value: object): value is BookingInfoResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('idempKey' in value) || value['idempKey'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('prepayment' in value) || value['prepayment'] === undefined) return false;
    if (!('externalNumber' in value) || value['externalNumber'] === undefined) return false;
    if (!('externalCreatedAt' in value) || value['externalCreatedAt'] === undefined) return false;
    if (!('cancellationPolicy' in value) || value['cancellationPolicy'] === undefined) return false;
    if (!('placementCodes' in value) || value['placementCodes'] === undefined) return false;
    if (!('adultCount' in value) || value['adultCount'] === undefined) return false;
    if (!('propertyId' in value) || value['propertyId'] === undefined) return false;
    if (!('ratePlanId' in value) || value['ratePlanId'] === undefined) return false;
    if (!('roomTypeId' in value) || value['roomTypeId'] === undefined) return false;
    if (!('arrival' in value) || value['arrival'] === undefined) return false;
    if (!('departure' in value) || value['departure'] === undefined) return false;
    if (!('childAges' in value) || value['childAges'] === undefined) return false;
    if (!('mealPlan' in value) || value['mealPlan'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    if (!('createBookingToken' in value) || value['createBookingToken'] === undefined) return false;
    return true;
}

export function BookingInfoResponseFromJSON(json: any): BookingInfoResponse {
    return BookingInfoResponseFromJSONTyped(json, false);
}

export function BookingInfoResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingInfoResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'status': json['status'],
        'idempKey': json['idempKey'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'total': json['total'],
        'prepayment': json['prepayment'],
        'externalNumber': json['externalNumber'],
        'externalCreatedAt': (new Date(json['externalCreatedAt'])),
        'cancellationPolicy': CancellationPolicyInfoDtoFromJSON(json['cancellationPolicy']),
        'placementCodes': json['placementCodes'],
        'adultCount': json['adultCount'],
        'propertyId': json['propertyId'],
        'ratePlanId': json['ratePlanId'],
        'roomTypeId': json['roomTypeId'],
        'countLettersReview': json['countLettersReview'] == null ? undefined : json['countLettersReview'],
        'arrival': (new Date(json['arrival'])),
        'departure': (new Date(json['departure'])),
        'childAges': json['childAges'],
        'mealPlan': json['mealPlan'],
        'fullPlacementsName': json['fullPlacementsName'] == null ? undefined : json['fullPlacementsName'],
        'checksum': json['checksum'],
        'createBookingToken': json['createBookingToken'],
    };
}

  export function BookingInfoResponseToJSON(json: any): BookingInfoResponse {
      return BookingInfoResponseToJSONTyped(json, false);
  }

  export function BookingInfoResponseToJSONTyped(value?: BookingInfoResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'status': value['status'],
        'idempKey': value['idempKey'],
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'total': value['total'],
        'prepayment': value['prepayment'],
        'externalNumber': value['externalNumber'],
        'externalCreatedAt': ((value['externalCreatedAt']).toISOString()),
        'cancellationPolicy': CancellationPolicyInfoDtoToJSON(value['cancellationPolicy']),
        'placementCodes': value['placementCodes'],
        'adultCount': value['adultCount'],
        'propertyId': value['propertyId'],
        'ratePlanId': value['ratePlanId'],
        'roomTypeId': value['roomTypeId'],
        'countLettersReview': value['countLettersReview'],
        'arrival': ((value['arrival']).toISOString()),
        'departure': ((value['departure']).toISOString()),
        'childAges': value['childAges'],
        'mealPlan': value['mealPlan'],
        'fullPlacementsName': value['fullPlacementsName'],
        'checksum': value['checksum'],
        'createBookingToken': value['createBookingToken'],
    };
}

